<div [cdkTrapFocusAutoCapture]="true" cdkTrapFocus>
	<modal-header-default
		[options]="{
			headerTitleKey: null,
			headerTitle: ('payment_processing' | translate)
		}"
		class="border">
	</modal-header-default>
	<div class="wrapper">
		<loading-spinner class="spinner green loader-big no-padding"></loading-spinner>
		<div class="taking-longer"> {{ "checkout_deposit_taking_longer" | translate }}</div>
		<div class="text-item"> {{ "taking_longer_deposit_info" | translate }}</div>
	</div>

	<div class="button-wrapper">
		<button class="btn btn-primary btn-lg font-bold btn-close" (click)="close()">{{
			"leave_trade" | translate
		}}</button>
	</div>
</div>
